let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gz4V7")).then(() => parcelRequire('lQ0xm'));